import { Component, OnInit,EventEmitter } from '@angular/core';
import { ApiRequestService } from '../../../_services/api-request.service';
import { MaterializeAction } from 'angular2-materialize';

declare var $:any;
declare var Materialize:any;
@Component({
  selector: 'app-casesimilarity',
  templateUrl: './casesimilarity.component.html',
  styleUrls: ['./casesimilarity.component.css']
})
export class CasesimilarityComponent implements OnInit {

  detail_modal = new EventEmitter<string | MaterializeAction>();
  ColumnList;
  
  keyword = "";
  DataList;
  loading;
  Count;

  constructor(private apirequest: ApiRequestService) { }

  ngOnInit() {
    this.GetData();
    this.GetColumns(); 
  }

  GetColumns(){
    let input;
   
    input =  {action:"get_search_portal_columns", column_name:"", val_to_search:""};
    
    
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res);
            
      if(res.status === "True") {
        console.log(res.msg);
        this.ColumnList = res.msg;
        // console.log(this.DataList[0][this.ColumnList[0]]);
      } else if(res.status === "False") {
          this.msg_view(res.msg);
      }       
    });
  }

  GetData(){
    this.loading = undefined;
    this.DataList = undefined;
    console.log('Data Call');
    
    let input;
   
    input =  {action:"get_search_portal_sample_data", column_name:"", val_to_search:""};
    
    
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res);
            
      if(res.status === "True") {
        console.log(res.msg);
        this.DataList = res.msg;
        this.loading = "Stop";
      } else if(res.status === "False") {
          this.msg_view(res.msg);
          this.loading = "Stop";
      }       
    });
  }

  Search(item,event){
    this.DataList = undefined;
    this.loading = undefined;
    this.keyword = event;
    let key_list = this.keyword.split(",");
    console.log(key_list);
    
    console.log(item +' Search Call');
    console.log(this.keyword);
    
    let input;
   
    input =  {action:"get_search_portal_filter", column_name:item, val_to_search:key_list};
    console.log(input);
    
    if(this.keyword == ""){
      this.GetData();
    } else {
      this.apirequest.customize_flow(input).subscribe(res => {
        console.log(res);
              
        if(res.status === "True") {
          console.log(res.msg);
          this.DataList = res.msg;
          this.Count = res.count;
          this.loading = "undefined";
        } else if(res.status === "False") {
            this.msg_view(res.msg);
            this.loading = "undefined";
            this.Reset();
        }       
      });
    }
    
  }

  msg_view(msg_data) {
    $(document).ready(function() {
      Materialize.toast(msg_data.toString(), 3000, 'grey darken-4');
    });
  }

  data_detail;
  col_name;

  detail(item) {
    this.data_detail = item;
    this.col_name = Object.keys(this.data_detail);
    this.detail_modal.emit({action: 'modal', params: ['open']});
    console.log(item);
    console.log(this.col_name);
    console.log(this.data_detail);   
    
  }

  dt_close(){
    this.detail_modal.emit({action: 'modal', params: ['close']});
  }
  

  Reset(){
    this.keyword = '';
    $("input").val("");
    $("input").removeClass("valid");
    this.GetData();
  }

  
}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/casesimilarity/casesimilarity.component.ts